import { Maybe } from "graphql/jsutils/Maybe";

import { Slice } from "../store.decl";

import { Call } from "@/states/call";

export type CustomCall = Omit<
  Call,
  | "lineName"
  | "lineLanguage"
  | "transcriptionLanguage"
  | "callsReason"
  | "voicemailsReason"
>;

export type CallSliceState = {
  call: Maybe<CustomCall>;
  setCall: (call: Maybe<CustomCall>) => void;
};

export const createCallSlice: Slice<CallSliceState> = (set) => ({
  call: null,
  setCall: (call) => {
    set(() => ({
      call,
    }));
  },
});
